// Prosthesis variants — multi-select on the Profile page for users whose
// adaptiveSubmodes includes 'amputee'. Each variant maps to library tags so
// the user can jump from their profile straight into a relevant exercise
// subset.
//
// Per founder direction: label-only, no blurbs. If we need
// disambiguation later we'll add them, but for now the labels stand alone.

export const PROSTHESIS_VARIANTS = [
  { id: 'transtibial', label: 'Below-knee (transtibial)' },
  { id: 'transfemoral', label: 'Above-knee (transfemoral)' },
  { id: 'knee-disarticulation', label: 'Through-knee (knee disarticulation)' },
  { id: 'hip-disarticulation', label: 'Hip disarticulation / Hemipelvectomy' },
  { id: 'transradial', label: 'Below-elbow (transradial)' },
  { id: 'transhumeral', label: 'Above-elbow (transhumeral)' },
  { id: 'shoulder-disarticulation', label: 'Shoulder disarticulation' },
  { id: 'partial-foot', label: 'Partial-foot' },
  { id: 'partial-hand', label: 'Partial-hand / digit' },
  { id: 'sport-blade', label: 'Sport / running blade' },
  { id: 'microprocessor-knee', label: 'Microprocessor knee' },
  { id: 'no-prosthesis', label: 'No prosthesis (crutches / wheelchair / mobility aid)' },
];

// Maps a variant id → library tags that surface the most relevant exercises
// when the user taps through. Tags must match those used in
// `data/exercises.js` (e.g. 'adaptive', 'iron-limb', 'prosthesis-off',
// 'wheelchair', 'one-arm', 'unilateral', 'seated', 'rehab').
export const VARIANT_TO_LIBRARY_TAGS = {
  'transtibial':              ['adaptive', 'iron-limb', 'prosthesis-off', 'unilateral'],
  'transfemoral':             ['adaptive', 'iron-limb', 'prosthesis-off', 'unilateral', 'glute-activation'],
  'knee-disarticulation':     ['adaptive', 'iron-limb', 'prosthesis-off', 'unilateral'],
  'hip-disarticulation':      ['adaptive', 'iron-limb', 'wheelchair', 'seated'],
  'transradial':              ['adaptive', 'iron-limb', 'one-arm', 'anti-rotation'],
  'transhumeral':             ['adaptive', 'iron-limb', 'one-arm', 'anti-rotation'],
  'shoulder-disarticulation': ['adaptive', 'iron-limb', 'one-arm', 'anti-rotation'],
  'partial-foot':             ['adaptive', 'iron-limb', 'unilateral'],
  'partial-hand':             ['adaptive', 'iron-limb', 'one-arm'],
  'sport-blade':              ['adaptive', 'iron-limb', 'unilateral'],
  'microprocessor-knee':      ['adaptive', 'iron-limb', 'unilateral', 'glute-activation'],
  'no-prosthesis':            ['adaptive', 'iron-limb', 'wheelchair', 'seated', 'rehab'],
};

export const variantLabel = (id) =>
  PROSTHESIS_VARIANTS.find((v) => v.id === id)?.label || id;
